import { UNAVAILABLE_ITEM_NOTIFICATION_KEY } from '../sbRespNotificationConstants.js';

// components
import { SharedNotificationsWrapper } from '../../../shared/SharedNotificationsWrapper.jsx';
import { SbRespUnavailableItemLoader } from './SbRespNotificationUnavailableItemLoader.jsx';

export const SbRespNotificationUnavailableItem = () => (
    <SharedNotificationsWrapper type={UNAVAILABLE_ITEM_NOTIFICATION_KEY}>
        {({ isEnabled }) => <SbRespUnavailableItemLoader isEnabled={isEnabled} />}
    </SharedNotificationsWrapper>
);
